export const DocumentType = {
  CSV: 'CSV',
  PDF: 'PDF',
};
